import PropTypes from 'prop-types';
import ActionDefaultAccountCreditCard from './ActionDefaultAccountCreditCard';
import DestroyAccountCreditCard from './DestroyAccountCreditCard';

function AccountCreditCardActions({
  creditCard,
  refetch = null,
  isExpired = false,
}) {
  return (
    <span className="isolate inline-flex rounded-md shadow-xs">
      <ActionDefaultAccountCreditCard
        id={creditCard.id}
        refetch={refetch}
        defaultCard={creditCard.defaultCard}
        isExpired={isExpired}
      />
      <DestroyAccountCreditCard
        id={creditCard.id}
        refetch={refetch}
        defaultCard={creditCard.defaultCard}
      />
    </span>
  );
}

AccountCreditCardActions.propTypes = {
  creditCard: PropTypes.object.isRequired,
  refetch: PropTypes.func,
  isExpired: PropTypes.bool,
};

export default AccountCreditCardActions;
